// The program ids a user is allowed to read, optionally narrowed to the ones
// they asked for: a requested program the user doesn't have never comes back,
// so an HTTP caller can't widen their own scope by passing programIds.
//
// Used by the agave program and funder controllers before hitting their PG
// adapters — funders are scoped by program too, via the
// funder<->program-partner mapping.
//
// A user with no programs gets nothing. That is stricter than the two reads
// this stands in for, deliberately:
//
// - RoutesApi's getProgramFilter (api/lib/routes/index.js) returns `{}` for
//   them, i.e. no program restriction at all;
// - legacy `funders.list()` (api/lib/funders/api/read/list.js) falls back to
//   the caller's requested programIds when `user.programs` is empty, so the
//   request itself decides the scope.
//
// Neither is safe on a route whose scope must come from the session rather than
// the query string. Legacy `program.list()` already behaves like this one: it
// reads `user.programs` and takes no programIds at all.
const scopedProgramIds = (user, requestedIds = []) => {
  const userPrograms = (user && user.programs) || []
  if (!requestedIds || !requestedIds.length) return userPrograms

  return requestedIds.filter(id => userPrograms.includes(id))
}

module.exports = { scopedProgramIds }
